/**
* @ngdoc component
* @name help.component:itxHelpContent
* @description
* Help content text
*/
(function() {
    'use strict';

    var itxHelpContent = {
        bindings: {
            content: '<'
        },
        controllerAs: '$ctrl',
        controller:   itxHelpContentCtrl,
        templateUrl: 'help-content.component.html'
    };

    itxHelpContentCtrl.$inject = [];

    function itxHelpContentCtrl () {
       
        this.$onInit = function () {
            window.scrollTo(0,0);

            setTimeout(function(){
                $(' .ma-help-page rich-text ul' ).each(function(){
                    var seeMoreFound = false;
                    var $ul = $(this);
                    $ul.find('li').each(function(){
                        var $el = $(this);
                        if(seeMoreFound){
                            $el.addClass('hidden');
                            $el.addClass('removable');
                        }
                        var $a = $el.find('a[href$="see-more"]');
                        if($a.length>0){
                            $a.click(function(e){
                                e.preventDefault();
                                e.stopPropagation();

                                $ul.find('li.removable').each(function(){
                                    var $el = $(this);

                                    $el.toggleClass('hidden');
                                });
                                $a.parent().remove();

                            });
                            seeMoreFound = true;
                            $('.ma-help-page rich-text ul' ).addClass('custom-covid');
                        }
                        
                    });
                });
            },1000);
           
        };

    }

    angular.module('itxApp.help')
    .component('itxHelpContent',itxHelpContent);

})();